import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import swal from "sweetalert";
import { useForm } from "react-hook-form";
import CloseIcon from "@mui/icons-material/Close";
import "./game.css";
import Header from "../components/Header";

function Sicbo() {
    axios.interceptors.request.use(
        (config) => {
            const token = localStorage.getItem("user");
            if (token) {
                config.headers["Authorization"] = `Bearer ${token}`;
            }
            return config;
        },
        (error) => {
            return Promise.reject(error);
        }
    );
    const [loading, setLoading] = useState(false);
    const [profile, setProfile] = useState(null);
    const [game, setGame] = useState(null);
    const [title, setTitle] = useState(null);
    const [isShow, setShow] = useState(false);
    const navigate = useNavigate();
    useEffect(() => {
        axios
            .get(`${process.env.REACT_APP_API_URL}/auth/getUser`, {})
            .then((res) => {
                if (profile != res.data.data) {
                    setProfile(res.data.data);
                    localStorage.setItem("profile", JSON.stringify(res.data.data));
                }
            })
            .catch((err) => localStorage.removeItem("user"));
    }, []);

    useEffect(() => {
        axios.get(`${process.env.REACT_APP_API_URL}/auth/getUser`, {}).then((res) => {
            setProfile(res.data.data);
            localStorage.setItem("profile", JSON.stringify(res.data.data));
        });
    }, []);

    return (
        <>
            <Header profile={profile} />
            {loading == true ? (
                <div className="loading">
                    <div className="loader"></div>
                </div>
            ) : null}
            <div className="bg-lottery">
                <div className="container">
                    <div className="taste-box-title">
                        <img src={require("../../image/common/icon-taste.png")} />
                        <p>Trò Chơi</p>
                    </div>
                    <div className="box-card-game grid-5">
                        <div className="card-game">
                            <div className="card-game-image">
                                <img src={require("../../images/mb75s.png")} />
                            </div>
                            <div className="card-game-info">
                                <div className="card-game-title">Xổ số 75s</div>
                                <div onClick={() => navigate("/xs75s/lo2")} className="card-game-play">
                                    Vào trò chơi
                                </div>
                            </div>
                        </div>
                        <div className="card-game">
                            <div className="card-game-image">
                                <img src={require("../../images/st2p.png")} />
                            </div>
                            <div className="card-game-info">
                                <div className="card-game-title">Xổ số 120s</div>
                                <div onClick={() => navigate("/xs120s/lo2")} className="card-game-play">
                                    Vào trò chơi
                                </div>
                            </div>
                        </div>
                        <div className="card-game">
                            <div className="card-game-image">
                                <img src={require("../../images/xd45s.png")} style={{ transform: "scale(0.9)" }} />
                            </div>
                            <div className="card-game-info">
                                <div className="card-game-title">Xóc đĩa 45s</div>
                                <div onClick={() => navigate("/xd45s")} className="card-game-play">
                                    Vào trò chơi
                                </div>
                            </div>
                        </div>
                        <div className="card-game">
                            <div className="card-game-image">
                                <img src={require("../../images/xd1p.png")} style={{ transform: "scale(0.9)" }} />
                            </div>
                            <div className="card-game-info">
                                <div className="card-game-title">Xóc đĩa 60s</div>
                                <div onClick={() => navigate("/xd60s")} className="card-game-play">
                                    Vào trò chơi
                                </div>
                            </div>
                        </div>
                        <div className="card-game">
                            <div className="card-game-image">
                                <img src={require("../../images/tx45s.png")} style={{ transform: "scale(0.95)" }} />
                            </div>
                            <div className="card-game-info">
                                <div className="card-game-title">Tài xỉu 45s</div>
                                <div onClick={() => navigate("/tx45s")} className="card-game-play">
                                    Vào trò chơi
                                </div>
                            </div>
                        </div>
                        <div className="card-game">
                            <div className="card-game-image">
                                <img src={require("../../images/tx60s.png")} />
                            </div>
                            <div className="card-game-info">
                                <div className="card-game-title">Tài xỉu 60s</div>
                                <div onClick={() => navigate("/tx60s")} className="card-game-play">
                                    Vào trò chơi
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
export default Sicbo;
